<div *ngIf="contact">
  <div class="tw-gap-4 tw-align-middle tw-justify-items-start">
    <h4 class="!tw-font-bold !tw-text-xs !tw-uppercase tw-pl-2 tw-pt-2">
      {{contact.first}} {{contact.last}} 
      <span class="!tw-font-bold !tw-text-xs tw-px-4">
        {{contact.title ? contact.title : 'OWNER'}}
      </span>
      <span *ngIf="contact.percentOwnership" class="tw-rounded-full !tw-text-xs tw-border tw-px-4">
        {{contact.percentOwnership}}%
      </span>
    </h4>
  <div class="tw-grid tw-grid-cols-2 tw-gap-2 tw-gap-x-2 tw-pb-2">
    <div
      class="tw-grid tw-grid-flow-col tw-justify-between tw-px-4" 
      *ngFor="let element of contactElements;"
    >
      <span class="text-muted">{{ element.label }}</span>
      <span>
    <span class="extra-label text-muted" *ngIf="element.extraLabel">{{ element.extraLabel }}</span>
    <span [ngSwitch]="element.pipe">
      <span *ngSwitchCase="'address'" class="tw-whitespace-pre-wrap">{{element.value}}</span>
          <span *ngSwitchCase="'date'">{{ element.value | date  }}</span>
          <span *ngSwitchCase="'phone'">+{{ element.phoneCountryCode }} {{ element.value | phone: element.country }}</span>
      <span *ngSwitchCase="'ssn'">{{ element.value | ssn }}</span>
          <span *ngSwitchDefault>{{ element.value }}</span>
      </span>
    </span>
  </div>
</div>
